<template>
  <div class="ls-empty">
    <template v-if="!loading">
      <img
        width="142px"
        height="110px"
        src="https://cdnws.51tyty.com/lstyty/file/2023/11/03/ec6e9fde1ac29573651292dcce986ec6.png"
        alt=""
      />
      <div class="empty-data" v-if="EmptyContent != '暂无数据'">
        <slot name="content">默认内容</slot>
      </div>
      <div class="empty-data" v-else>{{ EmptyContent }}</div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    EmptyContent: {
      type: [String],
      default: "暂无数据",
    },
    loading: { // 加载中不展示当前缺省图
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less" scoped>
.ls-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  .empty-data {
    font-size: 14px;
    font-weight: 400;
    color: rgba(51, 51, 51, 0.46);
    line-height: 30px;
  }
}
</style>